import { useEffect, useState } from 'react';
import { projects } from './../../settings';
import './styles.css'


export default function Proyect() {
    let [dotSelected, setDotSelected] = useState(0);
    // let projects = ["counter", "2", "3"]; 

    
    let slides;
    let dots;

    let handleSlice = (e) => {
        if (e.target.id !== dotSelected) {
            dots[dotSelected].classList.remove("active-dot")
            setDotSelected(e.target.id)
            slides[dotSelected].style.display = 'none'
        }
    }

    useEffect(() => {
        if(!dots) dots = document.querySelectorAll('.dot-nav');
        if(!slides) slides = document.querySelectorAll('.slide');

        dots[dotSelected].classList.add("active-dot")
        slides[dotSelected].style.display = 'inline-block'

    }, [dotSelected])

    
    return (
        <div id="projects-container" data-aos="fade-right" className="component">
            
            <div className="slides">
                
                {
                    projects.map((el, i) => (
                        <a href={el.url}>
                            <div key={i}
                            className={`slide fade`}
                            style={i === 0 ? {display: "inline-block"} : {display: "none"}}>
                                <div className={`img ${el.name}`}></div>
                            </div>
                            {/* <div className="slide slide-responsive">
                                <img src="https://res.cloudinary.com/imgp/image/upload/v1655073490/projects/counter-first_dkokym.png"/>
                                <img src="https://res.cloudinary.com/imgp/image/upload/v1655073490/projects/counter-first_dkokym.png"/>
                            </div> */}
                        </a>
                    ))
                }
            </div>
            
            <div id="dots-wrapper" className="dots">

                {
                    projects.map((el, i) => <div key={i} 
                                                id={i} 
                                                className={i == 0 ? "dot-nav active-dot" : "dot-nav"} 
                                                onClick={e => handleSlice(e)}>
                                            </div>)
                }

            </div>
        </div>

    )
}